export const en: Record<string, string> = {
  'widget.title': 'Support',
  'widget.newTicket': 'New Ticket',
  'widget.trackTicket': 'Track Ticket',
  'form.title': 'Title',
  'form.titlePlaceholder': 'Brief summary of your issue',
  'form.description': 'Description',
  'form.descriptionPlaceholder': 'Describe your issue in detail...',
  'form.email': 'Email',
  'form.emailPlaceholder': 'your@email.com',
  'form.priority': 'Priority',
  'form.priorityLow': 'Low',
  'form.priorityMedium': 'Medium',
  'form.priorityHigh': 'High',
  'form.priorityCritical': 'Critical',
  // Deprecated alias kept so existing host translations overriding this key keep working.
  'form.priorityUrgent': 'Critical',
  'form.category': 'Category',
  'form.categoryNone': 'Select a category',
  'form.submit': 'Submit Ticket',
  'form.submitting': 'Submitting...',
  'form.cancel': 'Cancel',
  'form.attachment': 'Attach files',
  'success.title': 'Ticket Submitted!',
  'success.ticketNumber': 'Ticket #',
  'success.trackingToken': 'Your tracking token:',
  'success.trackingHint': 'Save this token to track your ticket status.',
  'success.copyToken': 'Copy Token',
  'success.copied': 'Copied!',
  'success.close': 'Close',
  'success.trackNow': 'Track Ticket',
  'tracker.title': 'Track Your Ticket',
  'tracker.tokenPlaceholder': 'Enter your tracking token (trk_...)',
  'tracker.submit': 'Track',
  'tracker.tracking': 'Tracking...',
  'tracker.status': 'Status',
  'tracker.priority': 'Priority',
  'tracker.created': 'Created',
  'tracker.replies': 'Replies',
  'tracker.noReplies': 'No replies yet.',
  'tracker.replyPlaceholder': 'Write a reply...',
  'tracker.sendReply': 'Send Reply',
  'tracker.sending': 'Sending...',
  'tracker.back': 'Back',
  'tracker.staff': 'Staff',
  'error.generic': 'Something went wrong. Please try again.',
  'error.validation': 'Please fix the highlighted fields and try again.',
  'error.network': 'Network error. Check your connection.',
  'error.server': 'The server is having trouble. Please try again in a moment.',
  'error.forbidden': 'You don’t have permission to perform this action.',
  'error.unauthenticated': 'Please sign in to continue.',
  'error.notFound': 'We couldn’t find what you were looking for.',
  'notification.dismiss': 'Dismiss',
  'error.tokenInvalid': 'Invalid or expired tracking token.',
  'error.required': 'This field is required.',
  'error.emailInvalid': 'Please enter a valid email address.',
  'error.titleMin': 'Title must be at least 5 characters.',
  'portal.title': 'Support Portal',
  'portal.myTickets': 'My Tickets',
  'portal.noTickets': 'No tickets yet.',
  'portal.newTicket': 'New Ticket',
  'widget.close': 'Close',
  'menu.newTicket': 'Submit a Ticket',
  'menu.newTicketDesc': 'Create a new support request',
  'menu.myTickets': 'My Tickets',
  'menu.myTicketsDesc': 'View and manage your tickets',
  'menu.trackTicket': 'Track a Ticket',
  'menu.trackTicketDesc': 'Check status with your tracking token',
  'menu.knowledgeBase': 'Knowledge Base',
  'menu.knowledgeBaseDesc': 'Browse help articles and guides',
  'menu.myTicketsPlaceholder': 'Sign in to view your tickets.',
  'menu.trackPlaceholder': 'Ticket tracking is coming soon.',
  'menu.kbPlaceholder': 'Knowledge base is coming soon.',
  'menu.preferences': 'Preferences',
  'menu.preferencesDesc': 'Language and appearance settings',
  'prefs.title': 'Preferences',
  'prefs.language': 'Language',
  'prefs.theme': 'Theme',
  'prefs.light': 'Light',
  'prefs.dark': 'Dark',
  'prefs.auto': 'System',
  'branding.poweredBy': 'Powered by',
  'attach.dropzone': 'Drop files here or click to browse',
  'attach.dropzoneActive': 'Drop files here',
  'attach.maxFiles': 'Maximum {max} files',
  'attach.remove': 'Remove',
  'attach.uploading': 'Uploading files...',
  'attach.uploadProgress': 'Uploading {name}... {percent}%',
  'attach.invalidType': 'File type not allowed',
  'attach.tooLarge': 'File exceeds maximum size',
  'attach.tooMany': 'Maximum number of files reached',
  'attach.download': 'Download',
  'mytickets.title': 'My Tickets',
  'mytickets.emailPrompt': 'Enter your email to view your tickets',
  'mytickets.emailPlaceholder': 'your@email.com',
  'mytickets.rememberMe': 'Remember me',
  'mytickets.lookup': 'Find My Tickets',
  'mytickets.lookingUp': 'Looking up...',
  'mytickets.noTickets': 'No tickets yet.',
  'mytickets.submitFirst': 'Submit your first ticket',
  'mytickets.noAccount': 'No tickets found for this email.',
  'detail.description': 'Description',
  'detail.attachments': 'Attachments',
  'detail.noAttachments': 'No attachments',
  'detail.replies': 'Conversation',
  'detail.noReplies': 'No replies yet.',
  'detail.replyPlaceholder': 'Write a reply...',
  'detail.sendReply': 'Send',
  'detail.sending': 'Sending...',
  'detail.replyAttachLabel': 'Attach files to this reply',
  'detail.replyAttachHint': 'Attach files',
  'detail.staff': 'Staff',
  'detail.you': 'You',
  'detail.loading': 'Loading ticket...',
  'track.title': 'Track a Ticket',
  'track.tokenPlaceholder': 'Enter tracking token (trk_...)',
  'track.submit': 'Track',
  'track.tracking': 'Tracking...',
  'track.recentTickets': 'Recent Tickets',
  'track.invalidToken': 'Invalid or expired tracking token.',
  'prefs.clearEmail': 'Clear saved email',
  'prefs.emailCleared': 'Email cleared',
  'auth.login': 'Login',
  'auth.logout': 'Logout',
  'auth.sessionExpired': 'Session expired. Please log in again.',
  'auth.loginRequired': 'Please log in to select a project.',
  'auth.noAuthConfigured': 'Authentication is not configured for this widget.',
  'auth.noAuthConfiguredHint': 'Please contact the site owner to enable at least one sign-in option.',
  'widget.expand': 'Expand',
  'widget.collapse': 'Collapse',
  'detail.originalRequest': 'Original request',
  'detail.status': 'Status',
  'detail.priority': 'Priority',
  'detail.created': 'Created',
  'detail.reference': 'Reference',
  'prefs.accentColor': 'Accent Color',
  'prefs.position': 'Widget position',
  'prefs.topStart': 'Top start',
  'prefs.topEnd': 'Top end',
  'prefs.bottomStart': 'Bottom start',
  'prefs.bottomEnd': 'Bottom end',
  'prefs.displayMode': 'Display',
  'prefs.display.popover': 'Popover',
  'prefs.display.side-sheet': 'Side sheet',
  'prefs.display.bottom-sheet': 'Bottom sheet',
  'prefs.sheetSide': 'Side',
  'prefs.side.start': 'Start',
  'prefs.side.end': 'End',
  'form.categoryPlaceholder': 'Select a category',
  'form.categoryBack': 'Back',
  'form.categorySelected': 'Category',
  'form.tags': 'Tags',
  'tag.addNew': 'Add tag',
  'tag.addFirst': 'Add your first tag',
  'tag.namePlaceholder': 'New tag name',
  'tag.exists': 'A tag with that name already exists.',
  'diag.title': 'Share diagnostic info',
  'diag.shareAll': 'Share diagnostic info with support',
  'diag.hint': 'Help us resolve your issue faster — nothing sensitive',
  'diag.showIncluded': 'See what\u2019s included',
  'diag.hideIncluded': 'Hide what\u2019s included',
  'diag.screenResolution': 'Screen resolution',
  'diag.deviceType': 'Device type',
  'diag.timezone': 'Timezone',
  'diag.referrerUrl': 'Referrer URL',
  'diag.language': 'Browser language',
  'diag.platform': 'Platform',
  'detail.resolve': 'Mark as Resolved',
  'detail.resolving': 'Resolving...',
  'detail.resolved': 'Resolved',
  'detail.sla': 'SLA',
  'category.addNew': 'Add category',
  'category.addUnder': 'under',
  'category.namePlaceholder': 'Category name',
  'form.categorySearch': 'Search categories',
  'form.categoryRoot': 'All',
  'form.categoryNoMatch': 'No categories match your search.',
  'form.categoryLeaf': 'No sub-categories here.',
  'form.categoryClear': 'Clear',
  'category.exists': 'This category already exists',
  'category.limitReached': 'Category limit reached — upgrade your plan',
  'project.select': 'Select Project',
  'project.switch': 'Switch Project',
  'project.switchDesc': 'Change the active project',
  'project.loading': 'Loading projects...',
  'project.noProjects': 'No projects available',
  'project.current': 'Current project',
  'prefs.resetToDefaults': 'Reset to defaults',
  'prefs.resetConfirm': 'Reset all preferences to the host defaults?',
}
